import React, { createElement } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { useT } from '../utils/i18n';
export function Footer() {
  const t = useT();
  return <footer className="pt-12 border-t border-white/10 transition-colors duration-300 bg-[#000000]" data-id="element-796" data-mp="32o4b2ak1486j">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12" data-id="element-797" data-mp="36p6buvtlgsam">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-8 border-b border-white/20 pb-8" data-id="element-798" data-mp="36nd5ziqt2c3o">
          <div className="md:col-span-2" data-id="element-799" data-mp="3ucxmluzhkx9s">
            <Link to="/" className="inline-block mb-4" data-id="element-800" data-mp="38z9qtqtv33y">
              <Logo imgClassName="h-10 w-auto" invertOnLight={false} cycleEvery={3} data-id="element-801" data-mp="36mrefh5qqqd" />
            </Link>
            <p className="text-sm font-medium leading-relaxed max-w-sm text-[#ffffff]" data-id="element-802" data-mp="3lgoocjn8w4p8">
              {t('footer.tagline')}
            </p>
          </div>

          <div data-id="element-803" data-mp="29ydvdx2r0y8b">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-804" data-mp="29xm1qrsppako">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#cccccc]" data-id="element-805" data-mp="2evxa0y3czd0s">
              <li data-id="element-806" data-mp="3l9sj15twaup0">
                <a href="tel:206-619-3742" className="hover:text-white/70 transition-colors" data-id="element-807" data-mp="3lbdecxo1ahnx">
                  (206) 619-3742
                </a>
              </li>
              <li data-id="element-808" data-mp="3v8hq03k96uqh">
                <a href="mailto:info@206gravel.com" className="hover:text-white/70 transition-colors" data-id="element-809" data-mp="3v916dfu99b2e">
                  info@206gravel.com
                </a>
              </li>
              <li data-id="element-810" data-mp="81pejgi0et8b">Bonney Lake, WA</li>
            </ul>
          </div>

          <div data-id="element-811" data-mp="34gt971ke92u">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-812" data-mp="32w3rvu3xgbu">
              Products
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#cccccc]" data-id="element-813" data-mp="hriipwfto62j">
              <li data-id="element-814" data-mp="ctgy372qzyoy"><Link to="/?category=Base%20%26%20Compaction#materials" className="hover:text-white/70 transition-colors" data-id="element-815" data-mp="ctgznbiec6r2">Base &amp; Compaction</Link></li>
              <li data-id="element-816" data-mp="qr5hsbl2wzsf"><Link to="/?category=Clear%20%26%20Drain#materials" className="hover:text-white/70 transition-colors" data-id="element-817" data-mp="qr5g875fkrqb">Clear &amp; Drain</Link></li>
              <li data-id="element-818" data-mp="tw5yw7u65sn9"><Link to="/?category=Soil%2C%20Mulch%20%26%20Org.#materials" className="hover:text-white/70 transition-colors" data-id="element-819" data-mp="tw5xc3eitkl5">Soil, Mulch &amp; Org.</Link></li>
              <li data-id="element-820" data-mp="13tansffeg27r"><Link to="/?category=Quarry%20Rock#materials" className="hover:text-white/70 transition-colors" data-id="element-821" data-mp="13tkds30g29dg">Quarry Rock</Link></li>
              <li data-id="element-822" data-mp="18l2dknqqe3wu"><Link to="/?category=Landscape%20%26%20Decor#materials" className="hover:text-white/70 transition-colors" data-id="element-823" data-mp="18l2c0jb31vuq">Landscape &amp; Decor</Link></li>
            </ul>
          </div>

          <div data-id="element-824" data-mp="1hjw6o44usc5n">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-825" data-mp="1hje28k81ermn">
              {t('footer.resources')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#cccccc]" data-id="element-826" data-mp="1mhpcux65p65x">
              <li data-id="element-827" data-mp="1rhk637dem7u5">
                <Link to="/compare" className="hover:text-white/70 transition-colors" data-id="element-828" data-mp="1ri3jcas4081u">
                  {t('nav.compareMaterials')}
                </Link>
              </li>
              <li data-id="element-829" data-mp="3tb17vueusegz">
                <Link to="/delivery-prep" className="hover:text-white/70 transition-colors" data-id="element-830" data-mp="3tai036ix36go">
                  {t('footer.deliveryPrep')}
                </Link>
              </li>
              <li data-id="element-831" data-mp="25nlrt25032yn">
                <Link to="/delivery-zones" className="hover:text-white/70 transition-colors" data-id="element-832" data-mp="25n3yoedmx4uy">
                  {t('nav.deliveryZones')}
                </Link>
              </li>
              <li data-id="element-833" data-mp="1wp0a197crryx">
                <Link to="/blog" className="hover:text-white/70 transition-colors" data-id="element-834" data-mp="1wpjsqs4tuke0">
                  {t('footer.blog')}
                </Link>
              </li>
              <li data-id="element-835" data-mp="2pc4i5n1qsmex">
                <Link to="/help" className="hover:text-white/70 transition-colors" data-id="element-836" data-mp="2pdpcpco245cs">
                  {t('footer.materialQuiz')}
                </Link>
              </li>
              <li data-id="element-837" data-mp="2fezwdobt6syn">
                <Link to="/service-areas" className="hover:text-white/70 transition-colors" data-id="element-838" data-mp="2fdf11who75zq">
                  Service Areas
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center text-sm font-medium text-white/60" data-id="element-839" data-mp="13xgnpgfglxsp">
          <p data-id="element-840" data-mp="2rtmu46fi2d2e">
            &copy; {new Date().getFullYear()} 206Gravel. {t('footer.rights')}
          </p>
          <div className="mt-4 md:mt-0 space-x-6" data-id="element-841" data-mp="2wokda66hu2t0">
            <Link to="/privacy-policy" className="hover:text-white transition-colors" data-id="element-842" data-mp="2iw456qyqjel8">
              {t('footer.privacy')}
            </Link>
            <Link to="/terms-of-service" className="hover:text-white transition-colors" data-id="element-843" data-mp="2ns1mazhtooz2">
              {t('footer.terms')}
            </Link>
            <Link to="/refund-policy" className="hover:text-white transition-colors" data-id="element-844" data-mp="3fltwpnbtjga9">
              {t('footer.refund')}
            </Link>
          </div>
        </div>
      </div>

      {/* Our Network — thin horizontal strip pinned to the very bottom of
                                          the site. Forest-green background, black text. */}
      <div className="w-full bg-[#00754A]" data-id="element-845" data-mp="1q52mifvu30wy">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex flex-row flex-nowrap items-center justify-center gap-x-3 sm:gap-x-5 text-[11px] sm:text-sm font-bold text-black whitespace-nowrap overflow-x-auto scrollbar-hide" data-id="element-846" data-mp="1v601kjljreu8">
          <span className="uppercase tracking-[0.1em] sm:tracking-[0.14em] shrink-0 font-[500] text-[#17A347]" data-id="element-847" data-mp="1imcv23cz9qlx">
            Our Network
          </span>
          <a href="https://253gravel.com" className="hover:text-black/70 transition-colors font-[500] shrink-0 text-[12px] text-[#17A347]" data-id="element-848" data-mp="1rnsuxh662abw">
            253gravel.com
          </a>
          <a href="https://206gravel.com" className="hover:text-black/70 transition-colors font-[500] shrink-0 text-[12px] text-[#17A347]" data-id="element-849" data-mp="13vm0ink04df4">
            206gravel.com
          </a>
          <a href="https://425gravel.com" className="hover:text-black/70 transition-colors font-[500] shrink-0 text-[12px] text-[#17A347]" data-id="element-850" data-mp="1dp2xu1jckanj">
            425gravel.com
          </a>
        </div>
      </div>
    </footer>;
}